module.exports = __webpack_public_path__ + "static/media/safari-3 2.1f50981c.png";